import React, { useMemo, useState } from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./_WorkflowTarefaDataPrazo.less";
import PropTypes from "prop-types";
import ActionBar from "../../../components/action-bar";
import ActionLink from "../../../components/action-link";
import useFormatter from "../../../hooks/useFormatter";
import { ClockCircleOutlined } from "@ant-design/icons";
import InputDate from "../../../components/input-date";
import moment from "moment";
import WorkflowTarefaInfoTag from "../_WorkflowTarefaInfoTag";

export default function WorkflowTarefaArquivamento(props) {
  const { dataArquivamento } = props;
  const { formatDate } = useFormatter();

  let className = styles["workflow-tarefa-data-prazo"];
  if (!dataArquivamento) className += " " + styles["nao-preenchido"];
  if (true) className += " " + styles["read-only"];

  if (dataArquivamento)
    return (
      <div className={className}>
        <div>
          <WorkflowTarefaInfoTag icon={<ClockCircleOutlined />} text={formatDate(dataArquivamento)} status="default" />
        </div>
      </div>
    );

  return <div className={className}>(não preenchido)</div>;
}

WorkflowTarefaArquivamento.propTypes = {
  dataArquivamento: PropTypes.string,
  onSubmit: PropTypes.func,
  readOnly: PropTypes.bool,
};
